import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import EcheancesRecuValide from './EcheancesRecuValide';

import { CheckCircle, FileText, Download, Eye, Printer, FolderOpen, Plus, UserPlus } from 'lucide-react';

export default function RecuResult({ result, onAction, onNewRecu, onViewAll }) {
  if (!result) return null;

  return (
    <Card className="border-2 border-emerald-300 bg-emerald-50/30" data-testid="recu-result">
      <CardContent className="pt-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
            <CheckCircle className="h-7 w-7 text-emerald-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-bold text-emerald-800">Recu ESS genere avec succes</h3>
            <p className="text-emerald-600 mt-1">{result.message}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 text-sm">
              <div><span className="text-gray-500">Numero</span><p className="font-mono font-bold text-emerald-700 text-lg">{result.recu.numero}</p></div>
              <div><span className="text-gray-500">Montant Global</span><p className="font-bold">{result.recu.montant_ttc?.toFixed(2)} EUR</p></div>
              <div><span className="text-gray-500">Date</span><p className="font-medium">{result.recu.date_emission}</p></div>
              {result.recu.raison_sociale && <div><span className="text-gray-500">Beneficiaire</span><p className="font-medium">{result.recu.raison_sociale}</p></div>}
            </div>
            {result.adherent_cree && (
              <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center gap-3" data-testid="recu-adherent-cree-info">
                <UserPlus className="h-5 w-5 text-blue-600 shrink-0" />
                <div className="text-sm">
                  <p className="font-semibold text-blue-800">Adherent enregistre automatiquement</p>
                  <p className="text-blue-600">{result.adherent_cree.raison_sociale} — N&deg; {result.adherent_cree.numero_membre}</p>
                </div>
              </div>
            )}
            {result.recu?.ged_classee && (
              <div className="mt-3 p-3 bg-indigo-50 border border-indigo-200 rounded-lg flex items-center gap-3" data-testid="recu-ged-classee-info">
                <FolderOpen className="h-5 w-5 text-indigo-600 shrink-0" />
                <div className="text-sm">
                  <p className="font-semibold text-indigo-800">Classe automatiquement dans la GED</p>
                  <p className="text-indigo-600">Document accessible depuis l&apos;espace GED ESS</p>
                </div>
              </div>
            )}
            <EcheancesRecuValide recuId={result.recu.id} />
            <div className="flex flex-wrap gap-3 mt-5">
              <Button onClick={() => onAction('view', result.recu)} className="bg-blue-600 hover:bg-blue-700" data-testid="recu-view-btn"><Eye className="h-4 w-4 mr-2" /> Visualiser</Button>
              <Button onClick={() => onAction('download', result.recu)} variant="outline" className="border-emerald-300 text-emerald-700" data-testid="recu-download-btn"><Download className="h-4 w-4 mr-2" /> Telecharger</Button>
              <Button onClick={() => onAction('print', result.recu)} variant="outline" data-testid="recu-print-btn"><Printer className="h-4 w-4 mr-2" /> Imprimer</Button>
              <Button onClick={() => onAction('ged', result.recu)} variant="outline" className="border-indigo-300 text-indigo-700" data-testid="recu-ged-btn"><FolderOpen className="h-4 w-4 mr-2" /> Classer GED</Button>
              <Button variant="outline" onClick={onNewRecu} data-testid="recu-new-btn"><Plus className="h-4 w-4 mr-2" /> Nouveau Recu ESS</Button>
              <Button variant="ghost" onClick={onViewAll}><FileText className="h-4 w-4 mr-2" /> Voir tous les Recus ESS</Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
